import { render, staticRenderFns } from "./ParButton.vue?vue&type=template&id=edcd8174&scoped=true&"
import script from "./ParButton.vue?vue&type=script&lang=js&"
export * from "./ParButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcd8174",
  null
  
)

export default component.exports